import { useEffect } from "react";
import { useAuthContext } from "authentication";
import { useAppDispatch, actions } from "store";
export var useAuthenticateUser = function () {
    var userId = useAuthContext().userId;
    var dispatch = useAppDispatch();
    useEffect(function () {
        if (!userId) {
            throw new Error("User not authenticated");
        }
        dispatch(actions.setUserId(userId));
    }, [dispatch, userId]);
};
